import TelegramAuthWidget from './TelegramAuthWidget';

export default TelegramAuthWidget;
